/** Templates tab pane — saved one-click trade recipes. */
import {
  Loader2, Bookmark, Plus, Play, Pencil, Trash2,
} from 'lucide-react';

export default function TemplatesPane({ templates, loading, isAr, onOpenNew, onEdit, onDelete, onExecute, connectedCount, executingId }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs text-white/50">
          {isAr
            ? `${templates.length} قالب — اضغط أي واحد للتنفيذ الفوري`
            : `${templates.length} template(s) — click any to execute instantly`}
        </span>
        <button
          onClick={onOpenNew}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#d4af37]/15 border border-[#d4af37]/40 text-[#d4af37] hover:bg-[#d4af37]/25 text-xs font-bold"
          data-testid="tpl-new"
        >
          <Plus className="h-3.5 w-3.5" />
          {isAr ? 'قالب جديد' : 'New template'}
        </button>
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-10 text-white/40">
          <Loader2 className="h-5 w-5 animate-spin" />
        </div>
      ) : templates.length === 0 ? (
        <div className="text-center py-10">
          <Bookmark className="h-9 w-9 text-white/20 mx-auto mb-2" />
          <p className="text-sm text-white/50 mb-1">
            {isAr ? 'لا توجد قوالب بعد' : 'No templates yet'}
          </p>
          <p className="text-[11px] text-white/30">
            {isAr ? 'مثال: "Scalp XAUUSD" لتفعيل أمر بلوت 0.05 بضغطة' : 'e.g. "Scalp XAUUSD" for one-click 0.05 lot orders'}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {templates.map((t) => (
            <div
              key={t.id}
              className="rounded-xl border p-3 group"
              style={{
                background: `${t.color || '#d4af37'}0a`,
                borderColor: `${t.color || '#d4af37'}33`,
              }}
              data-testid={`tpl-card-${t.id}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5 mb-1">
                    <span
                      className="w-2 h-2 rounded-full shrink-0"
                      style={{ background: t.color || '#d4af37' }}
                    />
                    <h4 className="text-sm font-bold text-white truncate">{t.name}</h4>
                  </div>
                  <div className="text-[10px] text-white/50 space-y-0.5">
                    <div>
                      {t.symbol} · <span className="uppercase font-bold">{t.mode}</span>
                      {t.mode === 'market' ? ` · ${t.side.toUpperCase()}` : ` · ${t.order_type.replace('_', ' ').toUpperCase()}`}
                      {' '}· lot <span className="text-white font-mono">{t.volume}</span>
                    </div>
                    {t.entry_price && <div>Entry: <span className="font-mono">{t.entry_price}</span></div>}
                    <div>
                      {t.tp && <>TP <span className="text-emerald-300 font-mono">{t.tp}</span> · </>}
                      {t.sl && <>SL <span className="text-red-300 font-mono">{t.sl}</span></>}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-end gap-1 shrink-0">
                  <button
                    onClick={() => onExecute(t)}
                    disabled={executingId === t.id || connectedCount === 0}
                    className="flex items-center gap-1 px-2 py-1 rounded text-[10px] font-bold border transition disabled:opacity-40"
                    style={{
                      background: t.color || '#d4af37',
                      borderColor: t.color || '#d4af37',
                      color: '#000',
                    }}
                    data-testid={`tpl-run-${t.id}`}
                  >
                    {executingId === t.id
                      ? <Loader2 className="h-3 w-3 animate-spin" />
                      : <><Play className="h-2.5 w-2.5" />{isAr ? 'نفّذ' : 'Run'}</>}
                  </button>
                  <div className="flex items-center gap-0.5">
                    <button
                      onClick={() => onEdit(t)}
                      className="p-1 rounded text-white/40 hover:text-white/80 hover:bg-white/5"
                      title={isAr ? 'تعديل' : 'Edit'}
                      data-testid={`tpl-edit-${t.id}`}
                    >
                      <Pencil className="h-2.5 w-2.5" />
                    </button>
                    <button
                      onClick={() => onDelete(t.id)}
                      className="p-1 rounded text-white/40 hover:text-red-400 hover:bg-red-500/10"
                      title={isAr ? 'حذف' : 'Delete'}
                      data-testid={`tpl-delete-${t.id}`}
                    >
                      <Trash2 className="h-2.5 w-2.5" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
